import type { ICellRendererParams } from 'ag-grid-community';
import clsx from 'clsx';

import { Popover } from '../../popover/Popover';
import { EMPTY_VALUE } from '../valueFormatters';

import { DATA_ATTRIBUTE_PREVENT_AG_GRID_ON_ROW_CLICKED } from './constants';

import styles from './multiValueCellRenderer.module.scss';

export type IMultiValueCellRendererParams = ICellRendererParams;

export const MultiValueCellRenderer = ({
  value,
  formatValue,
}: IMultiValueCellRendererParams) => {
  if (value === undefined) {
    return value;
  }

  if (!Array.isArray(value)) {
    throw new TypeError(
      `MultiValueCellRenderer called with a non-array value: ${JSON.stringify(
        value
      )}`
    );
  }

  if (value.length === 0) {
    return formatValue?.(value) ?? EMPTY_VALUE;
  }

  const formattedValues = value.map((v) => formatValue?.(v) ?? v);
  const isMultiValueCell = formattedValues.length > 1;

  return (
    <div data-testid="multiValueCellRendererRoot" className={styles['root']}>
      <Popover
        disabled={!isMultiValueCell}
        content={
          <ul className={styles['tooltip-values']}>
            {formattedValues.map((v, i) => (
              <li key={i}>{v}</li>
            ))}
          </ul>
        }
        position="top"
        classNames={{
          content: styles['popover-content'],
        }}
      >
        <div
          {...(isMultiValueCell &&
            DATA_ATTRIBUTE_PREVENT_AG_GRID_ON_ROW_CLICKED)}
          className={clsx(styles['label'], {
            [styles['label--withTooltip']]: isMultiValueCell,
          })}
        >
          {formattedValues[0]}
          <span className={styles['more-count']}>
            {formattedValues.length > 1 ? (
              <>&nbsp;{`(+${formattedValues.length - 1})`}</>
            ) : (
              ''
            )}
          </span>
        </div>
      </Popover>
    </div>
  );
};
